// extracted by mini-css-extract-plugin
export default {"noNetworkBox":"index__noNetworkBox--lNy1z","emptyBox":"index__emptyBox--edi2s","emptyImg":"index__emptyImg--lhQHA","text":"index__text--mdaQj","loadBtn":"index__loadBtn--i_4_g"};